<template>
  <div class="activity_app_fragment_chatbox">
    <div class="activity_app_fragment_chatbox_conversation">
      <div ref="chat" v-if="selectedChat && selectedChat.conversation.length" class="activity_app_fragment_chatbox_conversation_raw">
        <uikit-QA v-for="(qa, i) in selectedChat.conversation" :key="i" :qa="qa" />
      </div>
      <div v-else class="activity_app_fragment_chatbox_conversation_emptystate">
        <h1 style="margin-bottom:16px;">Chat, J'ai Pété!</h1>
        <p>L'IA la plus aboutie au monde!</p>
        <div class="activity_app_fragment_chatbox_conversation_emptystate_examples">
          <h2 style="margin-bottom: 16px">Examples</h2>
          <uikit-list light :items="examples" />
        </div>
      </div>
    </div>
    <div class="activity_app_fragment_chatbox_form">
      <uikit-input :loading="loading" v-model="searchString" @submit="ask" class="activity_app_fragment_chatbox_form_input" />
      <p>ChatJaiPété Jan 69 Version Free Research Preview. Our goal is to make AI systems funnier and able to come up with the best jokes.</p>
    </div>
  </div>
</template>

<script>
import EventBus from "@/plugins/eventbus";
import UikitInput from "@/views/components/uikit/component.uikit.input.vue";
import UikitQA from "@/views/components/uikit/component.uikit.qa.vue";
import UikitList from "@/views/components/uikit/component.uikit.list.vue";

export default {
  name: "ActivityAppFragmentChatbox",
  components: {
    UikitInput,
    UikitQA,
    UikitList,
  },
  data() {
    return {
      selectedChat: null,
      loading: false,
      searchString: "",
      examples: [
        {
          name: '"Peux-tu m\'en apprendre plus sur le prout?"',
          callback: () => {
            this.ask("Peux-tu m'en apprendre plus sur le prout?", false);
          },
        },
        {
          name: '"Racontes moi un fait que je ne connais pas à propos du prout."',
          callback: () => {
            this.ask("Racontes moi un fait que je ne connais pas à propos du prout.", false);
          },
        },
        {
          name: '"J\'adore les fun facts sur le prout!"',
          callback: () => {
            this.ask("J'adore les fun facts sur le prout!", false);
          },
        },
      ],
    };
  },
  methods: {
    loadChatFromId(chatId) {
      this.searchString = "";
      this.selectedChat = this.$chatApp.chats[chatId];
    },
    async ask(question, fromSearchBar = true) {
      if (!this.loading && ((fromSearchBar && this.searchString != "") || !fromSearchBar)) {
        this.loading = true;
        this.searchString = "";
        if (this.selectedChat) {
          this.selectedChat.ask(question);
        } else if (!this.$chatApp.chats.length) {
          this.$chatApp.createChat();
          this.loadChatFromId(0);
          this.selectedChat.ask(question);
          EventBus.$emit("update_chat");
        }
        if (this.selectedChat && this.selectedChat.conversation.length) {
          this.selectedChat.name = this.selectedChat.conversation[0].question;
        }
        this.startScrollDownTimer();
        await this.selectedChat.currentConversation.fetchAnswer();
        this.stopScrollDownTimer();
        this.loading = false;
      }
    },
    startScrollDownTimer() {
      const scrollEl = this.$refs.chat;
      if (scrollEl) {
        this.scrollTimer = setInterval(() => {
          scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: "smooth" });
        }, 250);
      }
    },
    stopScrollDownTimer() {
      clearInterval(this.scrollTimer);
      this.scrollTimer = null;
    },
  },
  mounted() {
    EventBus.$on("selected_chat", (id) => {
      this.stopScrollDownTimer();
      if (this.selectedChat && this.selectedChat.currentConversation) {
        this.selectedChat.currentConversation.cancel();
      }
      this.loading = false;
      this.loadChatFromId(id);
    });
  },
};
</script>

<style scoped>
.activity_app_fragment_chatbox {
  display: flex;
  flex-direction: column;
  background: transparent;
  flex: 1;
  position: relative;
  box-sizing: border-box;
}
.activity_app_fragment_chatbox_conversation,
.activity_app_fragment_chatbox_conversation_emptystate {
  flex: 1;
  overflow: hidden;
}
.activity_app_fragment_chatbox_conversation_emptystate {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
}
.activity_app_fragment_chatbox_conversation_emptystate_examples {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.activity_app_fragment_chatbox_form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px;
  position: absolute;
  bottom: 0px;
  width: 100%;
  padding-top: 90px;
  background: linear-gradient(180deg, rgba(53, 55, 64, 0), #353740 58.85%);
  box-sizing: border-box;
  pointer-events: none;
}
.activity_app_fragment_chatbox_conversation_raw,
.activity_app_fragment_chatbox_conversation_emptystate {
  overflow: hidden;
  overflow-y: auto;
  height: 100%;
  padding-bottom: 150px;
  box-sizing: border-box;
}
.activity_app_fragment_chatbox_form_input {
  pointer-events: all !important;
}
</style>
